<template>
  <div class="ui inverted segment">
    <div class="ui inverted header">
      <i class="tasks icon"/>
      {{ localization.studyIdentifier.confirmationTitle }}
    </div>

    <div class="ui large inverted header">
      <center>{{ localization.studyIdentifier.studyIdentifierLabel }}: {{ userStudyIdentifier }}</center>
    </div>

    <div class="ui large inverted header">
      <center>{{ localization.studyIdentifier.studyGenderLabel }}: {{ localizedGenderText }}</center>
    </div>


    <div
      class="ui left floated tertiary circular button"
      @click="updateConfirmation(false)"><i class="chevron left icon"/> {{ localization.global.back }}</div>

    <div
      class="ui right floated tertiary circular button"
      @click="postStudyIdentifier"><i class="checkmark icon"/> {{ localization.global.confirm }} </div>
    <br>
    <br>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: '',
  props: {
    userStudyIdentifier: {
      type: String,
      required: true
    },
    userStudyGender: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['userId']),
    localizedGenderText () {
      if (this.userStudyGender === 'male') {
        return this.localization.studyIdentifier.studyGenderMale
      } else {
        return this.localization.studyIdentifier.studyGenderFemale
      }
    },
    baselineIdentifier () {
      return {
        'form_response': {
          'form_id': process.env.STUDY_IDENTIFIER_FORMID,
          'hidden': {
            'userid': this.userId,
            'recurring_order': 0
          },
          'definition': {
            'id': process.env.STUDY_IDENTIFIER_FORMID,
            'title': 'Square Study Identifier',
            'fields': [{
              'id': process.env.STUDY_IDENTIFIER_QNID,
              'title': 'What is your study identifier?',
              'type': 'multiple_choice',
              'allow_multiple_selections': false,
              'allow_other_choice': false
            }, {
              'id': process.env.STUDY_GENDER_QNID,
              'title': 'What is your gender?',
              'type': 'multiple_choice',
              'allow_multiple_selections': false,
              'allow_other_choice': false
            }]
          },
          'answers': [
            {
              'type': 'choice',
              'choice': {
                'label': this.userStudyIdentifier
              },
              'field': {
                'id': process.env.STUDY_IDENTIFIER_QNID,
                'type': 'multiple_choice'
              }
            },
            {
              'type': 'choice',
              'choice': {
                'label': this.userStudyGender
              },
              'field': {
                'id': process.env.STUDY_GENDER_QNID,
                'type': 'multiple_choice'
              }
            }
          ]
        }
      }
    }
  },
  methods: {
    ...mapActions(['updateUserStudyIdentifier', 'updateBrazeGender']),
    updateConfirmation (val) {
      this.$emit('updateConfirmation', val)
    },
    postStudyIdentifier () {
      this.updateUserStudyIdentifier(this.baselineIdentifier).then(() => {
        this.updateBrazeGender(this.userStudyGender).then(() => {}, (error) => {
          Rollbar.error('Error in updating Braze User Gender', error, this.userId, this.userStudyGender)
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/study/BaselineConfirmation.vue